<template>
  <div class="booking">
    <div class="booking-wrapper">
      <petstar-ribbon/>
      <div class="booking-divider booking-divider-left">
        <div class="booking-content">
          <booking-header/>
          <div class="w-100 d-block d-md-none px-4 mb-3">
            <home-button/>
          </div>
          <opening-hours/>
        </div>
        <div class="fixed-buttons d-none d-md-block">
          <home-button/>
        </div>
      </div>
      <div class="booking-divider booking-divider-right">
        <display-banner/>
        <div class="d-flex flex-column justify-content-center align-items-center mb-4 mt-5 py-5 py-md-0 px-4">
          <div v-if="success" role="alert" class="alert alert-info alert-icon" >
            <div class="alert-content">Password set! Redirecting to login in {{ countdown }}s.</div>
          </div>
          <template v-else>
            <error-banner v-if="error" :message="error"/>
            <div class="form-group w-100">
              <label for="password" class="w-100 text-left">Password</label>
              <password-input-validation v-model="password"/>
            </div>
            <button @click="trySetPassword" class="btn btn-tertiary w-100 mt-3" :disabled="disabled">
              <i class="fas fa-key"></i>
              Set Password
              <span v-if="loading" class="inline-loader"></span>
            </button>
            <button class="btn btn-outline-secondary w-100 mt-2"
              @click="gotoLogin">
              Back to Login
            </button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WebApi } from '../../services/WebApi'
import { ErrorHelper } from '../../helpers/ErrorHelper'
import { SiteCacheMixin } from '@/mixins/Site/SiteCacheMixin'
import { OpenSlotCacheMixin } from '@/mixins/Booking/OpenSlotCacheMixin'
import ErrorBanner from '../ErrorValidation/ErrorBanner.vue'
import PetstarRibbon from '../Booking/PetstarRibbon.vue'
import OpeningHours from '../Booking/OpeningHours.vue'
import Header from '../Booking/Header.vue'
import DisplayBanner from '../Booking/DisplayBanner.vue'
import HomeButton from '../Booking/HomeButton.vue'
import PasswordInputValidation from './PasswordInputValidation.vue'

export default {
  name: 'PasswordSet',
  mixins: [SiteCacheMixin, OpenSlotCacheMixin],
  data () {
    return {
      countdown: 3,
      password: '',
      loading: false,
      success: false,
      error: ''
    }
  },
  computed: {
    selected () {
      return this.sites.length > 0 ? this.sites[0] : null
    },
    selectedSiteId () {
      return this.selected ? this.selected.id : ''
    },
    resetId () {
      return this.$route.query.id
    },
    uploadModel () {
      return {
        password: this.password
      }
    },
    uploadModelValid () {
      return this.uploadModel.password.length > 0
    },
    disabled () {
      return !this.uploadModelValid || this.loading
    }
  },
  methods: {
    trySetPassword () {
      const self = this
      if (!self.uploadModelValid || self.loading) {
        return
      }
      self.error = ''
      self.success = false
      self.loading = true
      WebApi.post('ClientPasswordReset/' + self.resetId + '/Set', self.uploadModel)
        .then(() => {
          self.success = true
          self.startCountdown()
        })
        .catch(error => { self.error = ErrorHelper.getError(error) })
        .finally(() => { self.loading = false })
    },
    startCountdown () {
      const self = this
      const countdownInterval = setInterval(() => {
        if (self.countdown > 0) {
          self.countdown--
        } else {
          clearInterval(countdownInterval)
          const query = { siteId: this.selectedSiteId }
          if (this.postId) query.postId = this.postId
          this.$router.push({ name: 'login', query })
        }
      }, 1000)
    },
    gotoLogin () {
      const query = { siteId: this.selectedSiteId }
      if (this.postId) query.postId = this.postId
      this.$router.push({ name: 'login', query })
    }
  },
  components: {
    'opening-hours': OpeningHours,
    'booking-header': Header,
    'error-banner': ErrorBanner,
    'petstar-ribbon': PetstarRibbon,
    'display-banner': DisplayBanner,
    'home-button': HomeButton,
    'password-input-validation': PasswordInputValidation
  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  .booking-divider-right {
    height: max-content;
    min-height: 60vh !important;
  }
}
</style>
